export default {
    fallbackLocale: 'es-MX',
    locale: 'es-MX',
    messages: {
        'es-MX': {
            tittle: 'Administración Inteligente de Aplicación',
            home: 'Inicio',
            meetingRooms: 'Salas de junta',
            locations: 'localidad',
            maps: 'Mapas',
            users: 'Usuarios',
            parking: 'Estacionamiento',
            'room map': 'Mapas de Salas',
            'picture Rooms': 'Fotografias de Salas',
            attributes: 'Atributos',
            'section rules': 'Reglas de apartado',

            logoff: 'Cerrar sesión',
            localeCaption: 'Cambiar idioma a',
            searchCaption: 'Buscar',
            languaje: 'English',
            carsReport: 'Reporte de autos',
        },
        en: {
            tittle: 'Smart App Management',
            home: 'Home',
            meetingRooms: 'Meeting Rooms',
            locations: 'Locations',
            maps: 'Mapas',
            users: 'Users',
            parking: 'Parking',
            'room map': 'Room Map',
            'picture Rooms': 'Picture Rooms',
            attributes: '',
            'section rules': 'Section rules',

            logoff: 'Logoff',
            localeCaption: 'Set language to',
            searchCaption: 'Search',
            languaje: 'Español',
            carsReport: 'Cars Report',
        }
    }
}